import styled from "styled-components";

export const Main = styled.div`
  min-width: 150px;
  padding: 0;
`;

export const Styled = styled.div`
  display: flex;
  flex-direction: column;

  /* h4 {
    margin: 0 0 10px;
    font-size: 15px;
    font-weight: 700;
  } */

  .grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }
  .select {
    margin-bottom: 10px;
    h4 {
      width: 85px;
    }
  }

  .sslRow {
    margin-top: 10px;
    .switch {
      margin-bottom: 8px;
    }
    .select {
      margin-bottom: 6px;
      h4 {
        width: 115px;
      }
    }
    .caRow {
      margin-top: 4px;
      .switch {
        margin-bottom: 6px;
      }
    }
    .textarea > div {
      height: 80px;
      min-height: 80px;
    }
    .switchRow {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
      gap: 8px;
      margin-top: 8px;
      .switch {
        margin-bottom: 0;
      }
    }
  }

  /* .authWrapper > div {
    margin-bottom: 0;
  } */
  .actions {
      gap: 10px;
      position: relative;
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      margin-bottom: 11px;

      &::after {
         content: '';
         position: absolute;
         left: 0;
         bottom: 0;
         width: 100%;
         height: 0.5px;
         background-color: rgb(220, 220, 220);
      }
      .btn1 {
         .line {
            margin-bottom: 0;
            &::after { display: none; }
         }
      }

      .status {
        font-size: 13px;
        &.success {
          color: #16a34a;
        }
        &.error {
          color: #dc2626;
        }
      }
    }

  .operationFields {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .authWrapper {
  }

  .textInput {
    margin-top: 0%;
    h4 {
      width: 100px;
    }
  }
  .mt-4 {
    margin-top: 1rem;
  }
  .mt-2 {
    margin-top: 0.5rem;
  }
  .mb-2 {
    margin-bottom: 0.5rem;
  }
  .mb-4 {
    margin-bottom: 1rem;
  }
`;